<template lang="html">
  <div class="paperquestion">
    <BigImageDialog ref="dialog"/>
    <div class="paperquestion__header">
      <!-- <i class="paperquestion__header-logo"></i> -->
    </div>
    <div class="paperquestion__body">
      <div class="paperquestion__main">
        <div
          class="paperquestion__content"
          @dblclick="handleImage"
          v-if="!isFilling">
          <katex :desc='content'></katex>
        </div>
        <div
          class="paperquestion__options"
          :class="{isFilling}"
          @dblclick="handleImage"
          >
          <div id="tal_qs_template" talqs-app></div>
          <div class="paperquestion__main-tail">
            <span
              :class="{
                'paperquestion__main-btn': true,
                'paperquestion__main-enable': isChoose,
                'paperquestion__main-disable': !isChoose,
              }"
              @click="handleEnsure"
            >
              确定
            </span>
            <div
              v-show="isShowTip"
              :class="{
                'paperquestion__main-tip': true,
                'paperquestion__main-tip_correct': isCorrect,
                'paperquestion__main-tip_wrong': !isCorrect,
              }"
            >
              <i class="paperquestion__main-tip-arrow"></i>
              <div class="paperquestion__main-tip-pan">
                <p>{{tipTxt}}!</p>
                <span
                  class="paperquestion__main-tip-next"
                  @click="handleNext"
                >
                  下一题
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import { getJudgeData } from '@/libs/tqi-interaction-units/src/index';
import { flatMapDeep } from 'lodash';
import BigImageDialog from '@/components/BigImageDialog.vue';
import katex from '@/components/katex.vue';

export default {
  name: 'PaperQuestion',

  props: {
    queData: {
      type: Object,
      default: () => {},
    },
    ansData: {
      type: Object,
      default: () => {},
    },
    pattern: {
      type: Number,
      default: 1,
    },
    bundleExamStatus: {
      type: Number
    },
    allowEnterAgain: {
      type: Number,
      default: 1
    },
    everUnPublished: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      isShowTip: false,
      isChoose: false,
      isCorrect: true,
      tipTxt: '回答正确',

      result: {
        judge: [],
        data: [],
      },
    };
  },

  computed: {
    watchObj() {
      return {
        queData: this.queData,
        ansData: this.ansData,
      };
    },
    resultBoo() {
      return flatMapDeep(this.resultObj[0].result).every(item => item === 1);
    },
    resultObj() {
      let data;
      let result;
      if (this.result.data.length === 1) {
        data = this.result.data[0].stuAnswer || '';
        result = this.result.judge[0].judge || '';
      } else {
        data = this.result.data.map((item) => {
          if (item) {
            return item.stuAnswer || [];
          }
          return [];
        });
        result = this.result.judge.map((item) => {
          if (item) {
            return item.judge || [0];
          }
          return [0];
        });
      }
      return [{
        queId: this.queData.queId,
        data,
        result,
      }];
    },
    ratio() {
      try {
        if (this.resultBoo) {
          return 1;
        }
        if (this.queData.childList.length > 0) {
          let total = 0;
          let right = 0;
          this.queData.childList.forEach((child, index) => {
            total += child.score;
            if (this.resultObj[0].result[index].every(item => item === 1)) {
              right += child.score;
            }
          });
          return right / total;
        }
        return 0;
      // eslint-disable-next-line no-console
      } catch (e) { console.log(e); }
      return 0;
    },
    // 题干
    content() {
      return `<p style="float:left;">${this.queData.logicQuesTypeId === '2' ? '(多选)' : ''}</p>${this.queData.content}`;
    },
    isFilling() {
      return this.queData.logicQuesTypeId === '4';
    },
  },

  watch: {
    watchObj() {
      this.isChoose = false;
      this.isShowTip = false;
      this.renderQs();
    },
  },

  methods: {
    handleImage(evt) {
      if (evt.srcElement.nodeName === 'IMG') {
        this.$refs.dialog.openDialog(evt.srcElement.src);
      }
    },
    handleEnsure() {
      // 如果作答过 则可以提交
      if (this.isChoose) {
        switch (this.pattern) {
          case 2:
            if (this.everUnPublished) {
              // 显示反馈 回显正误
              if (this.resultBoo) {
                this.isCorrect = true;
                this.tipTxt = '回答正确';
              } else {
                this.isCorrect = false;
                this.tipTxt = '不太对哦';
              }
              this.isShowTip = true;
              this.$emit('ensure', {
                obj: this.resultObj,
                type: this.queData.logicQuesTypeId,
                ratio: this.ratio,
              });
            } else {
              this.$emit('ensure', {
                obj: this.resultObj,
                type: this.queData.logicQuesTypeId,
                ratio: this.ratio,
              });
            }
            break;
          case 1:
          default:
            // 显示反馈 回显正误
            if (this.resultBoo) {
              this.isCorrect = true;
              this.tipTxt = '回答正确';
            } else {
              this.isCorrect = false;
              this.tipTxt = '不太对哦';
            }
            this.isShowTip = true;

            /* global TalqsInteraction */
            this.setData(this.resultObj);
            this.$emit('ensure', {
              obj: this.resultObj,
              type: this.queData.logicQuesTypeId,
              ratio: this.ratio,
            });
        }
      }
      this.isChoose = false;
    },
    handleNext() {
      this.$emit('next');
    },
    setData(obj) {
      if (this.queData.logicQuesTypeId === '9') {
        TalqsInteraction.setData(this.queData.childList.map((item, index) => ({
          data: obj[0].data[index],
          queId: item.queId,
          result: obj[0].result && obj[0].result[index],
        })));
      } else {
        TalqsInteraction.setData([{
          data: [...obj[0].data],
          queId: obj[0].queId,
          result: obj[0].result,
        }]);
      }
    },
    renderQs() {
      // 渲染前清理sdk缓存的数据
      TalqsInteraction.removeData();
      this.$nextTick(() => {
        // 获取 dom 根节点
        const app = document.getElementById('tal_qs_template');

        /* global TalqsTemplate */
        app.innerHTML = TalqsTemplate.render(this.queData, {
          hideDifficulty: true,
          hideSource: true,
          hideCamera: true,
        });
        /* global MathJax */
        if (MathJax) window.MathJax.Hub.Queue(['Typeset', MathJax.Hub, app]);


        // 答案初始化
        if (this.ansData.answer && this.ansData.result) {
          const isRight = (this.ansData.result === 2 ? 0 : 1);
          const tmpAnswer = {
            queId: this.queData.queId,
            data: JSON.parse(this.ansData.answer),
          };
          if (this.pattern === 1) {
            tmpAnswer.result = JSON.parse(this.ansData.answer).map(() => isRight);
            if (isRight) {
              this.isCorrect = true;
              this.tipTxt = '回答正确';
            } else {
              this.isCorrect = false;
              this.tipTxt = '不太对哦';
            }
            this.isShowTip = true;
          }
          this.setData([tmpAnswer]);
          if (!isRight && this.pattern === 1) {
            const judgeData = getJudgeData(this.queData);
            /* global judge */
            this.result = JSON.parse(JSON.stringify({
              judge: judge(judgeData),
              data: judgeData,
            }));
            this.setData(this.resultObj);
          }
        }
        this.resize();
      });
    },
    resize() {
      this.$nextTick(() => { TalqsTemplate.autoLayout(); });
    },
  },

  mounted() {
    // /* global TalqsTemplate */
    const talComponents = TalqsTemplate.components;
    TalqsTemplate.updateTemplateList({
      [talComponents.StemsWrapper]: {
        exclude: [talComponents.Content, talComponents.Index],
        components: [{
          name: 'content',
          template: `
                {{ if data.logicQuesTypeId === "4"}}
                  {{ if sdkRepoter() }}
                  {{/if}}
                  {{if data.content && !data.hideContent}}
                    {{ if getNotice(data.logicQuesTypeId)}}
                      <div class="talqs_notice">{{getNotice(data.logicQuesTypeId)}}</div>
                    {{/if}}

                    {{ if data.logicQuesTypeId == 13 }}

                  <div>{{data.queDesc}}</div>
                  <div class="talqs_line_cont" sort-line-container>
                    <ul class="talqs_word_line" sort-line></ul>  <ul class="talqs_word_line" sort-line></ul>
                  </div>
                  <div option-list-root>
                    {{#data.content | transContentToList:"   " | renderList:'<button class="talqs_options_content" sort-item="$[value]">$[value]</button>'}}
                  </div>
                    {{ else }}
                      <div class="talqs_content clearfix" id="content{{data.queId}}">
                        <span style="float:left;line-height:31px" class="hidden_in_main">{{index}}.</span>\
                        <div class="talqs_content_main">{{#data.content | transfromBlankContent:data}}</div>
                      </div>
                    {{/if}}
                  {{/if}}
                  {{ else }}
                    <div class="talqs_content hidden_in_main">
                      <span>{{index}}.</span><div class="talqs_content_main"><span style="float:left;">{{if data.logicQuesTypeId === "2"}}(多选){{/if}}</span>{{#data.content}}</div>
                    </div>
                  {{/if}}
                `,
          index: 0,
        }],
      },
    });
    this.renderQs();
    TalqsInteraction.onChange = (data) => {
      // 样式重置
      TalqsInteraction.setData([]);
      this.isShowTip = false;
      const judgeData = getJudgeData(this.queData, data);
      /* global judge */
      this.result = JSON.parse(JSON.stringify({
        judge: judge(judgeData),
        data: judgeData,
      }));
      this.isChoose = judgeData.every(item => item.stuAnswer && item.stuAnswer.length > 0);
    };
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },
  components: {
    BigImageDialog,
    katex
  },
};
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~@/assets/less/mixin.less";

.paperquestion {
  &__header {
    height: 48px;
    line-height: 48px;
    background-color: #37261f;
    padding: 0 16px;
    display: flex;
    align-items: center;
    &-logo {
      display: inline-block;
      width: 124px;
      height: 25px;
      vertical-align: middle;
      background-image: url("~@/assets/images/whiteLogo.png");
      background-repeat: no-repeat;
      background-size: 100%;
      cursor: pointer;
      &.nocursor {
        cursor: default!important;
      }
    }

  }
  &__body {
    position: absolute;
    top: 48px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
    .bg-img('~@/assets/images/paper-question');
    background-size: 287px 497px;
    background-position: center;
  }
  &__main {
    margin: 42px 16px 33px;
    width: calc(100% - 32px);
    height: calc(100% - 75px);
    display: flex;
    &-tail {
      position: absolute;
      width: 100%;
      text-align: center;
      height:80px;
      bottom:0;
      background:rgba(255,253,246,1);
      border-radius: 0 0 12px 12px;
      &::after {
        content: '';
        width: 100%;
        height: 5px;
        position: absolute;
        display: block;
        top: 0;
        z-index: -2;
        box-shadow:0px 2px 8px 0px rgba(0,0,0,0.27);
      }
    }
    &-btn {
      display: inline-block;
      width: 100px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      border-radius: 18px;
      position: absolute;
      top: calc(50% - 17px);
      left: calc(50% - 50px);
    }
    &-enable {
      background-color: #f1c151;
      border: 2px solid #b7885b;
      cursor: pointer;
      &:hover {
        color: #fff;
        background-color: #e6ad29;
      }
    }
    &-disable {
      background-color: #cecece;
      border: 2px solid #9d9d9d;
      cursor: not-allowed;
    }
    &-tip {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 150px;
      height: 100px;
      border: 2px solid;
      border-radius: 10px;
      transform: translate(75px, -50px);
      &-arrow {
        position: absolute;
        top: 50%;
        left: 0;
        display: block;
        width: 15px;
        height: 15px;
        transform: translate(-9px, -9px) rotate(45deg);
        border-left: 2px solid;
        border-bottom: 2px solid;
      }
      &-next {
        display: inline-block;
        width: 100px;
        height: 30px;
        line-height: 26px;
        border: 2px solid #000;
        border-radius: 15px;
        cursor: pointer;
      }
      &_correct {
        background-color: #ced882;
        border-color: #799748;
        .paperquestion__main-tip-arrow {
          background-color: #ced882;
          border-color: #799748;
        }
        .paperquestion__main-tip-next {
          background-color: #f1c151;
        }
      }
      &_wrong {
        background-color: #f1c151;
        border-color: #b7885b;
        .paperquestion__main-tip-arrow {
          background-color: #f1c151;
          border-color: #b7885b;
        }
        .paperquestion__main-tip-next {
          background-color: #fcf4e2;
        }
      }
    }
    .paperquestion__content {
      flex: 500 500 500px;
      background:rgba(255,253,246,1);
      box-shadow:0px 0px 8px 0px rgba(0,0,0,0.2);
      border-radius:12px;
      margin-right: 16px;
      padding: 32px;
      font-size:18px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:25px;
      overflow: auto;
    }
    .paperquestion__options {
      flex: 892 892 892px;
      background:rgba(255,253,246,1);
      box-shadow:0px 0px 8px 0px rgba(0,0,0,0.2);
      border-radius:12px;
      padding: 32px 0px 80px;
      overflow-y: visible;
      position: relative;
      z-index: 0;
      &.isFilling {
        /deep/.talqs .talqs_content {
          display: flex;
        }
      }
      /deep/.talqs {
        margin: 0px 33px 0px;
        height: 100%;
        overflow: auto;
        >.talqs_main {
          >.hidden_in_main.talqs_content {
            display: none;
          }
          >.talqs_content {
            >.hidden_in_main {
              display: none;
            }
          }
          .talqs_content {
            display: flex;
            font-size:18px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:25px;
            &_main {
              flex: 1 1 auto;
            }
          }
          .talqs_main + .talqs_main {
            margin-top: 32px;
          }
          // >.talqs_options_analyze,  >.talqs_subqs{

          // }
        }
      }
    }
  }
}
</style>

<style lang="less" rel="stylesheet/less">
.talqs>.talqs_main>.talqs_subqs>.talqs_main .talqs_content,
.talqs>.talqs_main>.talqs_subqs>.talqs_main .talqs_options,
.talqs>.talqs_main>.talqs_subqs>.talqs_main .talqs_subqs {
  margin-left: 0px;
}
#tal_qs_template {
  height: 100%;
  .talqs_options_columns_item {
    font-size:18px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:25px;
    &.talqs_wrong {
      .talqs_options_label,.talqs_options_content {
        color: #E4B13C;
        background-color: transparent;
      }
      .talqs_options_label::before {
        border-color: #E4B13C;
        background: radial-gradient(closest-side, #E4B13C 6px,  transparent 6px);
      }
    }
    &.talqs_right {
      .talqs_options_label,.talqs_options_content {
        color: #638733;
        background-color: transparent;
      }
      .talqs_options_label::before {
        border-color:#638733;
        background: radial-gradient(closest-side, #638733 6px,  transparent 6px);
      }
    }
  }
  .talqs_options_columns_item.talqs_active {
    background: transparent;

    .talqs_options_label,.talqs_options_content {
      color: #638733;
      background-color: transparent;
    }
    .talqs_options_label::before {
      border-color: #638733;
      background: radial-gradient(closest-side, #638733 6px,  transparent 6px);
    }
    img {
      border: solid 2px #638733;
    }
  }
  .talqs_options_label {
    float: left;
    border: none;
    display: inline;
    width: auto;
    height: auto;
    line-height: 24px;
    color: #000;
    margin: 2px 0;
    &::after {
      content: '.'
    }
    &::before {
      content: '';
      display: block;
      width:24px;
      height:24px;
      background:transparent;
      border:2px solid rgba(184,184,184,1);
      border-radius: 12px;
      float:left;
      margin-right: 12px;
    }
  }
  .talqs_options_content {
    margin-left: 13px;
  }

  .talqs_blank_input {
    border-bottom: 1px solid #b7885b;
    background-color: #f7e7c9;
    color: #000;
  }
  .talqs_blank_input.talqs_wrong {
    background-color: #E4B13C;
    border-color: #E4B13C;
  }
  .talqs_blank_input.talqs_right {
    background-color: #e5e7ba;
    border-color: #e5e7ba;
  }
  // 修复一行两个因为margin被挤下去的问题
  .talqs_options .talqs_options_list_2 .talqs_options_rows {
    width: 48%;
  }
  .talqs_options_columns_item {
    align-items:flex-start;
  }
}
</style>
